import { getTagsByIds } from '@/apis/tags';
import { isTemplatePlaceholder } from '@/types';
import { RuleProperties } from '@react-awesome-query-builder/mui';
import { TagIdsFilter } from '@/types/searchFilterTypes';
import { FilterMapper, ValidationContext } from './filterMapperTypes';
import { AutocompleteGenericEntity } from '@australiangreens/ag-internal-components';

export const TagIdsMapper: FilterMapper = {
  checkIsIncomplete({ value }) {
    const isNoTagSelected = value[0].value.length === 0;
    return isNoTagSelected;
  },

  toFilter({ value }: RuleProperties): TagIdsFilter {
    if (!value) throw new Error('Missing value');

    if (value.length !== 1) throw new Error('Invalid value. Expected array of length 1');

    const nestedValue = value[0].value;
    let mappedValue;
    if (isTemplatePlaceholder(nestedValue)) {
      mappedValue = nestedValue;
    } else {
      const tags = value[0] as { value: AutocompleteGenericEntity[] };

      mappedValue = tags.value.map(({ id }) => {
        if (typeof id !== 'number') throw new Error('Invalid value. Expect array of numbers');
        return id;
      });
    }

    return { name: 'tagIds', value: mappedValue } as TagIdsFilter;
  },

  async fromFilter(filter: TagIdsFilter, { token, domainCode }: ValidationContext) {
    if (isTemplatePlaceholder(filter.value)) {
      return {
        field: filter.name,
        operator: 'any in',
        value: [
          {
            value: filter.value,
            errors: [],
          },
        ],
      };
    }
    const tags = await getTagsByIds(token, filter.value, domainCode);
    const hasMissingTags = tags.length < filter.value.length;
    const errors = hasMissingTags
      ? [{ field: 'tagIds', message: 'Missing tags', level: 'warning' as const }]
      : [];
    return {
      field: filter.name,
      operator: 'any in',
      value: [{ value: tags, errors }],
    };
  },
};
